import {
  Button,
  Input,
  Select,
  HStack,
  VStack,
  Box,
  Text,
  useToast
} from '@chakra-ui/react';
import { FaCar } from "react-icons/fa";
import { useForm } from 'react-hook-form';
import { BoxTitle } from '@/components/BoxTitle';
import { ModalAlert } from '@/components/ModalStyled/Modal';
import SimpleDatePicker from '@/components/DatePicker/index';

interface VeiculoFormData {
  placa: string;
  renavam: string;
  chassi: string;
  fabricante: string;
  modelo: string;
  combustivel: string;
  cor: string;
  ano: string;
  fabricacao: string;
  portas: string;
  potencia: string;
  cliente: string;
}

interface ModalVeiculoProps {
  isOpen: boolean;
  onClose: () => void;
  handleAddVeiculo: (formData: VeiculoFormData) => void;
}

const ModalVeiculo: React.FC<ModalVeiculoProps> = ({ isOpen, onClose, handleAddVeiculo }) => {
  const toast = useToast();
  const {
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    reset
  } = useForm<VeiculoFormData>({
    defaultValues: {
      placa: '',
      renavam: '',
      chassi: '',
      fabricante: '',
      modelo: '',
      combustivel: '',
      cor: '',
      ano: '',
      fabricacao: '',
      portas: '',
      potencia: '',
      cliente: ''
    }
  });


  const onSubmit = async (data: VeiculoFormData) => {
    const missingFields: string[] = [];

    Object.entries(data).forEach(([key, value]) => {
      if (!value.trim()) missingFields.push(key);
    });

    if (missingFields.length > 0) {
      toast({
        title: missingFields.length === 1
          ? `O campo ${missingFields[0]} é obrigatório.`
          : "Faltam campos obrigatórios a serem preenchidos.",
        status: "error",
        isClosable: true,
      });
      return;
    }

    handleAddVeiculo(data);
    toast({
      title: "Veículo adicionado com sucesso!",
      status: "success",
      isClosable: true,
    });
    reset();
    onClose();
  };

  return (
    <ModalAlert
      isOpen={isOpen}
      onClose={onClose}
      size='3xl'
      title={
        <Text fontSize={'xl'} ml={2}>Adicionar Veículo</Text>
      }
      body={
        <Box as="form" onSubmit={handleSubmit(onSubmit)}>
          <VStack spacing={4} align="stretch">
            <HStack>
              <HStack w='18%'>
                <BoxTitle title="Placa">
                  <Input name="placa" value={watch("placa")} onChange={(e) => setValue("placa", e.target.value)} placeholder=" Placa" />
                </BoxTitle>
              </HStack>
              <BoxTitle title="Renavam">
                <Input name="renavam" value={watch("renavam")} onChange={(e) => setValue("renavam", e.target.value)} placeholder="Renavam" />
              </BoxTitle>
              <BoxTitle title="Chassi">
                <Input name="chassi" value={watch("chassi")} onChange={(e) => setValue("chassi", e.target.value)} placeholder=" Chassi" />
              </BoxTitle>

            </HStack>
            <HStack>
              <BoxTitle title="Fabricante do Veículo">
                <Select name="fabricante" value={watch("fabricante")} onChange={(e) => setValue("fabricante", e.target.value)} placeholder="Selecione um fabricante">
                  <option>Ford</option>
                  <option>Chevrolet</option>
                </Select>
              </BoxTitle>
              <HStack w={'40%'}>
                <BoxTitle title="Ano">
                  <SimpleDatePicker onDateChange={(date) => setValue("ano", date)} />
                </BoxTitle>
                <BoxTitle title="Fabricação">
                  <SimpleDatePicker onDateChange={(date) => setValue("fabricacao", date)} />
                </BoxTitle>
              </HStack>
            </HStack>
            <HStack>
              <BoxTitle title="Modelo do Veículo">
                <Select name="modelo" value={watch("modelo")} onChange={(e) => setValue("modelo", e.target.value)} placeholder="Selecione um modelo">
                  <option>Fiesta</option>
                  <option>Onix</option>
                </Select>
              </BoxTitle>
              <Box w={'40%'}>
                <BoxTitle title="Cor">
                  <Select name="cor" value={watch("cor")} onChange={(e) => setValue("cor", e.target.value)} placeholder="Selecione uma cor">
                    <option>Branco</option>
                    <option>Preto</option>
                  </Select>
                </BoxTitle>
              </Box>
            </HStack>
            <HStack>
              <BoxTitle title="Tipo de Combustível">
                <Select name="combustivel" value={watch("combustivel")} onChange={(e) => setValue("combustivel", e.target.value)} placeholder="Selecione um tipo de combustível">
                  <option>Gasolina</option>
                  <option>Diesel</option>
                </Select>
              </BoxTitle>
              <HStack w={'40%'}>
                <BoxTitle title="Qtd Portas">
                  <Input name="portas" value={watch("portas")} onChange={(e) => setValue("portas", e.target.value)} placeholder="Qtd portas" />
                </BoxTitle>
                <BoxTitle title="Potência">
                  <Input name="potencia" value={watch("potencia")} onChange={(e) => setValue("potencia", e.target.value)} placeholder="Potência" />
                </BoxTitle>
              </HStack>
            </HStack>

            <BoxTitle title="Cliente / CPF">
              <Select name="cliente" value={watch("cliente")} onChange={(e) => setValue("cliente", e.target.value)} placeholder="Selecione um cliente">
                <option>Cliente 1</option>
                <option>Cliente 2</option>
              </Select>
            </BoxTitle>
          </VStack>
        </Box>
      }
      footer={
        <Button colorScheme="blue" onClick={handleSubmit(onSubmit)}>
          Confirmar
        </Button>
      }
    />
  );
};

export default ModalVeiculo;
